<template>
  <div class="m-box">
    <van-form @submit="onSubmit">
      <div class="x-input-no x-bottom-15">
        <van-field v-model="form.password" type="password" placeholder="请设置6-20位登录密码"
                   :rules="[{ required: true, message: '' },{ pattern, message: '请输入6-20位数字或英文密码' }]"/>
      </div>
      <div class="x-input-no x-bottom-15">
        <van-field v-model="form.verifyPassword" type="password" placeholder="请再次输入密码" :rules="[{ required: true, message: '' },{ pattern, message: '请输入6-20位数字或英文密码' }]"/>
      </div>
      <div class="x-flex-between">
        <van-button block class="x-btn-default m-btn" @click="backSubmit" native-type="button">
          <van-icon name="arrow-left" />  上一步
        </van-button>
        <van-button block class="x-btn-log m-btn" native-type="submit">
          立即注册 <van-icon name="arrow" />
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>

  export default {
    components: {},
    data () {
      return {
        form:{
          password:'',
          verifyPassword:'',
        },
//      /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z]{6,20}$/,
        pattern: /^[0-9a-zA-Z]{6,20}/,
      }
    },
    created () {

    },
    methods: {
      onSubmit(){
        if(this.form.password===this.form.verifyPassword){
          this.$emit('submit')
        }else {
          this.utils.toastNone('两次密码输入不一致，请重新输入！')
        }
      },
      backSubmit(){
        this.$emit('isOK',2)
      },
    },
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
  .m-box{
    .m-btn{
      width: 144px;
      margin-top: 48px;
    }
  }
</style>

